import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-maiia',
  templateUrl: './maiia.component.html',
  styleUrls: ['./maiia.component.scss']
})
export class MaiiaComponent implements OnInit {

  constructor(private configurationService: ConfigurationService) { }

  authSrv = this.configurationService.get().maiia.authSrv;
  idpCode = this.configurationService.get().maiia.idpCode;
  partnerId = this.configurationService.get().maiia.partnerId;

  ngOnInit(): void {
  }

}